/* eslint-disable */
import { useState } from 'react';

const initialState = [
    { "name": "notification", "initalValue": {} },
    { "name": "isPasswordCorrect", "initalValue": false },
]
export const globalState = {};
export const useStore = () => {
    for (const stateDetails of initialState) {
        const [ state, setState ] = useState(stateDetails["initalValue"]);
        globalState[stateDetails["name"]] = {
            state, setState
        }
    }
}
